export default __webpack_public_path__ + "media/images/images_v2/shadebas-29b0432ed5c882baaa42ff986f457177.png";